import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Añadimos useNavigate

const Aside = ({ isOpen, sidebarRef }) => {
  const location = useLocation();
  const navigate = useNavigate(); // Hook para redireccionar
  
  const isActive = (path) => location.pathname === path ? 'active' : '';

  // LÓGICA DE CERRAR SESIÓN

const handleLogout = () => {
  // 1. Limpiamos TODA la sesión de la pestaña actual
  sessionStorage.clear();

  // 2. Limpiamos localStorage por si quedó basura de versiones anteriores
  // Esto es VITAL para romper el bucle infinito que tenías
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('userRole');
  localStorage.removeItem('usuario_novatech');

  // 3. Redirigimos al Login y usamos 'replace' para que el usuario 
  // no pueda volver al Dashboard dándole al botón "Atrás" del navegador
  navigate('/login', { replace: true });
  
  // 4. Opcional: Forzar un refresco si notas que el estado de React se queda "pegado"
  // window.location.reload(); 
};

  return (

    <aside 
      ref={sidebarRef} 
      className={`sidebar ${isOpen ? 'active' : ''}`}
    >
      <Link to="/" className="logo">YCore Studio</Link>
      
      <nav className="sidebar__nav">

        <p className="sidebar__title">Gestión Publica</p>
        
        <Link to="/DashboardProductos" className={`sidebar__link ${isActive('/DashboardProductos')}`}>
          <i className="fa-solid fa-briefcase"></i> Servicios
        </Link>

        <Link to="/DashboardContactanos" className={`sidebar__link ${isActive('/DashboardContactanos')}`}>
          <i className="fa fa-envelope"></i> Mensajes
        </Link>        
        

        <Link to="/DashboardReseñas" className={`sidebar__link ${isActive('/DashboardReseñas')}`}>
          <i className="fa-solid fa-comments"></i> Reseñas
        </Link>



        <p className="sidebar__title">Gestión Administrativa</p>


        <Link to="/DashboardUsuarios" className={`sidebar__link ${isActive('/DashboardUsuarios')}`}>
          <i className="fa fa-user-shield"></i> Usuarios
        </Link>

        <Link to="/DashboardClientes" className={`sidebar__link ${isActive('/DashboardClientes')}`}>
          <i className="fa fa-users"></i> Clientes
        </Link>

        <Link to="/DashboardClienteServicios" className={`sidebar__link ${isActive('/DashboardClienteServicios')}`}>
          <i className="fa-solid fa-file-invoice-dollar"></i> Contratos & Pagos
        </Link>




        {/* --- BOTÓN DE CERRAR SESIÓN --- */}
        <div className="sidebar__footer">
          <button 
            onClick={handleLogout} 
            className="sidebar__link logout-button">
            <i className="fa-solid fa-right-from-bracket"></i> Cerrar Sesión
          </button>
        </div>


      </nav>

    </aside>
  );
};

export default Aside;